import groq from 'groq';

export const FEATURE_LIST = groq`
  features[] {
    title,
    description,
    "icon": select(
      defined(icon.asset) => {
        "alt": icon.alt,
        "url": icon.asset -> url,
        "height": icon.asset -> metadata.dimensions.height,
        "width": icon.asset -> metadata.dimensions.width,
      },
      null
    )
  }
`;

export const FEATURE_LIST_BLOCK = groq`
  _type == 'featureList' => @-> {
    ${FEATURE_LIST}
  }
`;
